import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"


import globalMU from "globalMU"

export type DefinirOidModalidadeEntregaParams = {
    identificadorItem: number,
    oidModalidadeEntregaItem: number,
    atualizarEstadoLegadoImediatamente?: boolean
    itemLegado?:any
}

export async function definirOidModalidadeEntregaItem(params: DefinirOidModalidadeEntregaParams) {
    try {
        globalMU.blockUI()
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirOidModalidadeEntregaItem(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificadorItem,
            params.oidModalidadeEntregaItem,
        )

        atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)
        } finally {
        globalMU.unblockUI()
    }
}